export const STORAGE_USER = "Maserati::CurrentUserID";
export const STORAGE_TOKEN = "Maserati::AuthToken";
export const STORAGE_LANG = "Maserati::UsedLang";
export const STORAGE_CSS = "Maserati::CSS";
export const STORAGE_FONTSIZE = "Maserati::FontSize";
export const STORAGE_THEME = "Maserati::Theme";
export const STORAGE_WELCOME = "Maserati::FirstTime";
